module.exports = __webpack_public_path__ + "static/img/header-theme-primary.d7024f7e.svg";